import { AfterViewInit, Component, OnInit, LOCALE_ID, Inject } from '@angular/core';
import { Notification } from 'src/app/shared/models/notification.model';
import { GlobalService } from 'src/app/shared/services/global.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-push-notifications',
    templateUrl: './push-notifications.component.html',
    styleUrls: ['./push-notifications.component.scss'],
    standalone: false
})
export class PushNotificationsComponent implements OnInit, AfterViewInit {

  userId: string = '';
  notifications: Notification[];
  confirmDelete: boolean = false;
  isLoading: boolean = true;
  constructor(@Inject(LOCALE_ID) private locale: string, public globalService: GlobalService,
              private notificationService: NotificationService,
              private router: Router
  ) { }

  async ngOnInit() { 
    this.userId = localStorage.getItem('CSBarcodeID');
    if (this.userId != null && this.userId != '')
       this.notifications = await this.notificationService.viewNotifications(this.userId);

    this.notifications.map(a => { 
      a.notificationDate = formatDate(a["notificationDate"], 'MM/dd/yy', this.locale).trim();

      a["selected"] = false;
    })
    this.isLoading = false;
  }

  ngAfterViewInit(): void {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "NOTIFICATIONS";        
    this.globalService.screenHeader = this.globalService.Get('NOTIFICATIONS');
  }

  ToggleSelection(notification)
  {
    notification.selected = !notification.selected; 
  }

  ApplySelectOperation(){
      let isAllSelected = this.isAllSelected();
      this.notifications?.map(a => { 
      a["selected"] = ! isAllSelected;
    })
  }

  getSelectOperationText()
  {
    if (this.isAllSelected() == true)
      return this.globalService.Get("UNSELECTALL");   
    else
      return this.globalService.Get("SELECTALL");
  }

  isAllSelected() {
    return (this.notifications?.findIndex(a => a["selected"] == false) == -1 && this.notifications?.length > 0);
  }

  isAnySelected() {
    return (this.notifications?.findIndex(a => a["selected"] == true) >= 0);
  }

  getSelectedCount() {
    let selectionCount = this.notifications?.filter(a => a["selected"]).length;
    let totalCount = this.notifications?.length;
    return "Selected Notifications:  " + selectionCount + "/" + totalCount;
  }

  openNotification(notification) {
    notification.isOpen = true;
    this.router.navigate(['/admin/cms/notification/' + notification?.messageUUID ]);
  }

  async deleteSelection() {
    let ret = await this.notificationService.deleteNotifications(this.userId, this.notifications?.filter(a => a["selected"] == true).map(b => b.messageUUID));
    if (ret == "success")
      this.notifications = this.notifications?.filter(a => a["selected"] != true);
    this.confirmDelete = false;
  }

}
 